module.exports = __webpack_public_path__ + "img/zzimg.8e18a35b.jpg";